import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_HOST || "https://api.edu.lumoscrm.kz/api/",
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If the error status is 401 and there is no originalRequest._retry flag,
    // it means the token has expired and we need to refresh it
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refresh_token = localStorage.getItem("refreshToken");

        if (refresh_token) {
          axios
            .post(originalRequest.baseURL + "auth/refresh", { refresh_token })
            .then((response) => {
              const { token, refresh_token } = response.data;
              localStorage.setItem("token", token);
              localStorage.setItem("refreshToken", refresh_token);
              originalRequest.headers.Authorization = `Bearer ${token}`;
              return axios(originalRequest);
            })
            .catch(() => {
              localStorage.removeItem("token");
              localStorage.removeItem("refreshToken");
            });
        } else {
          window.location.href = "/?auth=true";
        }
      } catch (error) {
        localStorage.removeItem("token");
      }
    } else if (error.response.status === 401 && originalRequest._retry) {
      window.location.href = "/?auth=true";
    }

    return Promise.reject(error);
  }
);

export default api;
